import { Api } from "../../Api";
import { Status } from "../../DataFrame";
import { ResponseResult } from "../FieldChangeResult";
import { IPicture } from "../Pictures/IPicture";
import { AccessLevel, Gender, IUser, Localization } from "./IUser";
import { IUsersService } from "./IUsersService";
import { UsersService } from "./UsersService";

export class User implements IUser {
    private _guid: string = "";
    private _cloudGuid: string = "";
    private _name: string = "";
    private _surname: string = "";
    private _phone: string = "";
    private _email: string = "";
    private _isAccountOnline: boolean = true;
    private _isAccountActive: boolean = true;
    private _isAccountBanned: boolean = true;
    private _notificationChannels: string[] = [];
    private _gender: Gender = Gender.Unknown;
    private _accessLevel: AccessLevel = AccessLevel.Any;
    private _localization: Localization = Localization.En_Us;
    private _softwareVersion: string = "";

    get Guid(): string {
        return this._guid;
    }

    set Guid(value: string) {
        this._guid = value;
    }

    get CloudGuid(): string {
        return this._cloudGuid;
    }

    set CloudGuid(value: string) {
        this._cloudGuid = value;
    }

    get Name(): string {
        return this._name;
    }

    set Name(value: string) {
        this._name = value;
    }

    get Surname(): string {
        return this._surname;
    }

    set Surname(value: string) {
        this._surname = value;
    }

    get Phone(): string {
        return this._phone;
    }

    set Phone(value: string) {
        this._phone = value;
    }

    get AccessLevel(): AccessLevel {
        return this._accessLevel;
    }

    set AccessLevel(value: AccessLevel) {
        this._accessLevel = value;
    }

    get Email(): string {
        return this._email;
    }

    set Email(value: string) {
        this._email = value;
    }

    get IsAccountOnline(): boolean {
        return this._isAccountOnline;
    }

    set IsAccountOnline(value: boolean) {
        this._isAccountOnline = value;
    }

    get IsActive(): boolean {
        return this._isAccountActive;
    }

    set IsActive(value: boolean) {
        this._isAccountActive = value;
    }

    get IsBanned(): boolean {
        return this._isAccountBanned;
    }

    set IsBanned(value: boolean) {
        this._isAccountBanned = value;
    }

    get NotificationChannels(): string[] {
        return this._notificationChannels;
    }

    set NotificationChannels(value: string[]) {
        this._notificationChannels = value;
    }

    get Gender(): Gender {
        return this._gender;
    }

    set Gender(value: Gender) {
        this._gender = value;
    }

    get Localization(): Localization {
        return this._localization;
    }

    set Localization(value: Localization) {
        this._localization = value;
    }

    get SoftwareVersion(): string {
        return this._softwareVersion;
    }
    
    set SoftwareVersion(value: string) {
        this._softwareVersion = value;
    }

    GetUserProfilePictureAsync(): Promise<IPicture | ResponseResult<Status>> {
        return Api.Get<IUsersService>(UsersService.ServiceName).GetUserProfilePictureAsync(({Guid: this._guid} as IUser));
    }

    SetUserProfilePictureAsync(base64PictureString: string): Promise<ResponseResult<Status>> {
        return Api.Get<IUsersService>(UsersService.ServiceName).SetUserProfilePictureAsync(({Guid: this._guid} as IUser), base64PictureString);
    }
}